import { Divider, Typography, Grid } from "@material-ui/core";
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { updateHeaderInfo, getPublicDecks, copyDeck, subscribeDeck, getUserDetails, trackPage } from "../actions";
import { PublicDeckCard } from "../components";
import { Link } from "react-router-dom";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import { LoadingCard, CopyrightWidget } from "../components";
import { deviceData, setContainer, getThisYear, setActiveNavigationWidget, HOME_TEXT_ARRAY } from "../common";
import { isBrowser, isElectron } from 'react-device-detect';

class PublicDeckList extends Component { 
    state = {
        loading: true,
        publicDecks: this.props.publicDecks,
        loadingtext: 'Loading Publicly Available Decks.',
    }

    randomtext = () => {
        const arr = HOME_TEXT_ARRAY;
    
        let cnt = 0;
    
        let interval = setInterval(() => {
            // const randomIndex = Math.floor(Math.random() * arr.length);
            let t = arr[cnt];
            this.setState({ ...this.state, loadingtext : t});
            cnt++;
        }, 1500, cnt);
    
        return this.setState({ ...this.state, interval: interval });
    }

    componentDidMount = async () => {
        await this.props.updateHeaderInfo({
            route:"/publicDecks", 
            name: "Public Decks", 
            iconTwo: 'menu',
            iconOne: 'home',
        });

        setActiveNavigationWidget("myDecksFooterIcon");
        window.scrollTo(0,0);

        const { mcid, key } = this.props.auth_feedback;
        const tracking = deviceData(this.props.location, 'navigate');

        await this.props.getPublicDecks({ 
            mcid: mcid, 
            key: key,
            tracking: tracking
        });

        return this.setState({ ...this.state, publicDecks: this.props.publicDecks, loadingtext: this.randomtext() })
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.publicDecks !== this.props.publicDecks) {
            this.setState({ ...this.state, publicDecks: this.props.publicDecks });
        }

        if (prevState.publicDecks !== this.state.publicDecks) {
            this.setState({ ...this.state, loading: false })
        }
    }

    addDeck = async (id) => {
        let obj = {
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            deckID: id
        }

        await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
        await this.props.copyDeck(obj);
        this.props.history.push('/myDecks');
    }

    subscribeDeck = async (id) => {
        let obj = {
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            deckID: id
        }
        await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
        await this.props.subscribeDeck(obj);
        this.props.history.push('/myDecks');
    }

    mapPublicDeckCards = () => {
        const publicDecks = this.props.publicDecks;

        if (typeof publicDecks !== 'undefined' && publicDecks.length > 0) {            
            return publicDecks.map((deck, index) => {
                return (
                    <PublicDeckCard
                        deckColor="neutralBlueCard" 
                        textColor="neutralBlueText"
                        buttonColor="neutralBlueCard"
                        index={index}
                        deckName={deck.deckname}
                        deckID={deck.deckID}
                        value={Number(deck.totalQuestions)}
                        gameMode={Number(deck.gameMode)}
                        titleClass="deck-card-title"
                        addDeck={this.addDeck}
                    />
                );
            });
        } else {
            return (
                <PublicDeckCard
                    deckColor="neutralBlueCard" 
                    textColor="neutralBlueText"
                    buttonColor="neutralBlueCard"
                    index={0}
                    deckName={"Testing Public Deck Name"}
                    deckID={0}
                    value={0}
                    gameMode={3}
                    titleClass="deck-card-title"
                    addDeck={this.addDeck}
                />
            );
        }
    };

    mapPublicDeckRows = () => {
        const publicDecks = this.props.publicDecks;
        if (typeof publicDecks !== 'undefined' && publicDecks.length > 0) {            
            return publicDecks.map((row, index) => {
                return (
                    <TableRow key={row.name}>
                        <TableCell>
                            <Link
                                to={{
                                    pathname: "/viewDeck",
                                    deckID: row.deckID,
                                    gameMode: (typeof row.gameMode !== 'undefined' ? row.gameMode : 3)
                                }}
                                className="text-blue"
                            >
                                {row.deckname}
                            </Link>
                        </TableCell>
                        {/* <TableCell align="center">{row.totalQuestions}</TableCell> */}
                        {/* <TableCell align="center" className="show-lg">{(row.isSpaced ? 'Yes' : 'No')}</TableCell> */}
                        {/* <TableCell align="center" className="">{(row.isOpen ? 'Yes' : 'No')}</TableCell> */}
                        <TableCell align="center">
                            <a onClick={() => this.subscribeDeck(row.deckID)} className="text-blue">
                                <CollectionsBookmarkIcon style={{fontSize: "1.5em"}} />
                            </a>
                        </TableCell>
                        {/* <TableCell align="center">
                            <a onClick={() => this.addDeck(row.deckID)} className="text-blue">
                                <FileCopyIcon style={{fontSize: "1.5em"}} />
                            </a>
                        </TableCell> */}
                    </TableRow>
                );
            });
        } else {
            return (
                <TableRow key="no-public-deck-record">
                    <TableCell colSpan={4} align="left">No Public Decks Available</TableCell>
                </TableRow>
            );
        }
    }

    render() {
        if (this.state.loading) {
            return <LoadingCard textarray={this.state.loadingtext}/>
        } else {
            return (
                <>
                    <div className="aua-overflow" style={setContainer(isBrowser)}>
                        <Typography className="homeDividerText">Public Decks</Typography>
                           

                        <div className="aua-container margin-bottom-24" style={{padding:"0"}}>                        
                            <Grid item xs={12}>
                                <TableContainer className="" component={Paper}>
                                    <Table style={{width: "100%"}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Deck Name</TableCell>
                                                {/* <TableCell align="center">Questions</TableCell> */}
                                                {/* <TableCell align="center" className="show-lg">Spaced</TableCell> */}
                                                {/* <TableCell align="center" className="">Open</TableCell> */}
                                                <TableCell align="center">Subscribe</TableCell>
                                                {/* <TableCell align="center">Copy</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.mapPublicDeckRows(this.props)}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </div>
                        
                        <CopyrightWidget 
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-16 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                </>
            );
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { publicDecks } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        publicDecks,
        auth_feedback,
        user_details
    };
};

const PublicDecksScreen = connect(mapStateToProps, { 
    updateHeaderInfo, getPublicDecks, copyDeck, subscribeDeck, getUserDetails, trackPage }
)(
    withRouter(PublicDeckList)
);

export { PublicDecksScreen };
